const productDeliveryEstimate = document.querySelectorAll(".line-item");
productDeliveryEstimate.forEach(function(item) {
    const leadtime = item.dataset.shipFromMc === 'true' ? 1 : Number(item.dataset.leadtime);
    const closingDate = new Date(item.dataset.closingDate)
    const openingDate = new Date(item.dataset.openingDate)

    const italianHolidays = [{month: "gennaio",day: 1},{month: "gennaio",day: 6},{month: "agosto",day: 15},{month: "novembre",day: 1},{month: "dicembre",day: 8},{month: "dicembre",day: 25},{month: "dicembre",day: 26},{month: "aprile", day: 25},{month: "maggio", day: 1},{month: "giugno", day: 2}]

    const months = ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"]
    const days = ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"]

    const isSaturday = (date) => {
        return days[date.getDay()] === "sabato"
    }

    const isSunday = (date) => {
        return days[date.getDay()] === "domenica"
    }

    const isClosed = (date) => {
        return date >= closingDate && date <= openingDate
    }

    const isHoliday = (date) => {
        for (let holiday of italianHolidays) {
            if (months[date.getMonth()] === holiday.month) {
                if (date.getDate() === holiday.day) {
                    return true
                }
            }
        }
        return false
    }

    const dateValidator = (date) => {
        return !isHoliday(date)
            && !isSaturday(date)
            && !isSunday(date);
    }

    const calculateEtd = (start_date, leadtime,isFirstDay) => {
        let addDays = new Date(start_date)
        if(isFirstDay) {
            if (isClosed(addDays)) {
                addDays = openingDate
            }
        }
        for (let i = 1; i <= leadtime; i++) {
            addDays.setDate(addDays.getDate() + 1)
            while (!dateValidator(addDays,isFirstDay)) {
                addDays.setDate(addDays.getDate() + 1)
            }
        }
        return addDays
    }

    const today = new Date()
    const deliveryTime = item.dataset.carrier === 'FERCAM' ?  leadtime + 4 : leadtime + 1
    const startDay = calculateEtd(today, deliveryTime,true)
    const endDay = calculateEtd(startDay, 1,false)

    item.getElementsByClassName("line-item__shipping-text")[0].textContent += `${days[startDay.getDay()]} ${startDay.getDate()} ${months[(startDay.getMonth())]} e ${days[endDay.getDay()]} ${endDay.getDate()} ${months[(endDay.getMonth())]}`;
});